import _ from 'lodash';
import * as React from 'react';
import { BodyCopyLink } from '../../../components/common/styles/globalStyles';
import ContentConstants from '../../../contentConstants';
import { ITrendGroup, ITrendSurvey, IValidationResult } from '../../../models';
import { Col3Col9, Section } from '../../common';
import TrendGroup from './TrendGroup';
import { TrendSurveys } from './TrendSurveys';

export interface IReportingTrendsProps {
	validationResults?: IValidationResult;
	trendSurveys: ITrendSurvey[];
	trendSurveysLoading: boolean;
	trendGroups: ITrendGroup[];
	firstTrendGroupItem?: ITrendGroup;
	selectedTrendGroupId?: string;
	selectedTrendGroupName: string;
	disabled?: boolean;
	onTrendGroupChange: (trendGroupId: string) => void;
}

export class ReportingTrends extends React.PureComponent<IReportingTrendsProps> {
	constructor(props: IReportingTrendsProps) {
		super(props);
	}

	public render() {
		const { trendSurveys, trendSurveysLoading, selectedTrendGroupName } = this.props;

		return (
			<Section id={ContentConstants.ID_REPORTING_TRENDS} sectionHeader={ContentConstants.SECTIONHEADERS_REPORTING_SETUP_TRENDS}>
				<Col3Col9 label={ContentConstants.SUBSECTIONHEADERS_INSTRUCTIONS}>
					<span>
						{ContentConstants.INSTRUCTIONALTEXT_REPORTING_TREND_1}
						<strong>{ContentConstants.INSTRUCTIONALTEXT_REPORTING_TREND_2}</strong>
						{ContentConstants.INSTRUCTIONALTEXT_REPORTING_TREND_3}
						<BodyCopyLink
							href={ContentConstants.INSTRUCTIONALTEXT_REPORTING_TREND_VIDEO_LINK}
							target={ContentConstants.INSTRUCTIONALTEXT_REPORTING_TREND_VIDEO_TARGET}
						>
							{ContentConstants.INSTRUCTIONALTEXT_REPORTING_TREND_VIDEO}
						</BodyCopyLink>
						.
					</span>
				</Col3Col9>
				<Col3Col9 label={ContentConstants.SUBSECTIONHEADERS_REPORTING_TREND}>
					<TrendGroup {...this.props} onChange={this.props.onTrendGroupChange} />
				</Col3Col9>
				<Col3Col9>
					<TrendSurveys loading={trendSurveysLoading} trendSurveys={trendSurveys} trendGroupName={selectedTrendGroupName} />
				</Col3Col9>
			</Section>
		);
	}
}
